import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Library.module.scss';
import CreationCard from '../../components/CreationCard/CreationCard';
import Icon from '../../components/Icon/Icon';
import { setTopNavbar } from '../../Reducers/actions/navbarActions';
import { fetchSavedCreationsByUser } from '../../Reducers/actions/creationsActions';
import CreationSkeleton from '../../components/CreationCard/CreationSkeleton';

const SavedCreations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const savedCreations = useSelector(state => state.creation.savedCreations);
  const loading = useSelector(state => state.creation.loading);
  const userId = useSelector(state => state.auth.user?.user_id);
  const fetchSaved = useSelector(state => state.creation.fetchSaved);

  const handleViewCreation = (creation_id) => {
    navigate(`/creations/${creation_id}`)
  }

  useEffect(() => {
    if (userId && !fetchSaved) {
      dispatch(fetchSavedCreationsByUser(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(setTopNavbar({
      title: 'Favourite Creations',
      showBackArrow: true,
    }))
  }, []);

  

  return (
    <div>
     
      <div className={styles.savedSection}>
        <div className={styles.verticalCardList}>
          {loading ? (
            [1, 2, 3].map((item) => <CreationSkeleton key={item} />)
          ) : (
            savedCreations && savedCreations.length > 0 ? (
              <>
                {savedCreations.map((item) => (
                  <CreationCard
                    key={item.creation_id}
                    title={item.title}
                    price={item.price}
                    thumbnailUrl={item.thumbnail_url}
                    category={item.category}
                    users={item.users}
                    tags={item.tags}
                    onClick={() => handleViewCreation(item.creation_id)}
                    media={item.media}
                  />
                ))}
                <div style={{ minHeight: 64 }} />
              </>
            ) : (
              <div className={styles.emptyState}>
                <Icon alias="library_v2" width={40} height={40} color="#d9d9d9" />
                <div className={styles.emptyText}>No saved creations yet.</div>
              </div>
            )
          )}
        </div>
        <div style={{ marginBottom: '32px' }} />
      </div>
    </div>
  );
};

export default SavedCreations; 